// extracted by mini-css-extract-plugin
export default {"heading":"GenerationTextArea_heading__Cdswl","input":"GenerationTextArea_input__vdURj"};